import fp from 'lodash/fp';

import { useSelector } from 'Modules/core/redux';

import { FeedbackReducer, SendedConfirmationTimeKey } from './types';
import { FEEDBACK_PATH, SENDED_CONFIRMATION_TIME_PATH } from './constanst';
import { LANDING_DOMAIN_PATH } from '../../constants';


export const useCodeTime = (email: SendedConfirmationTimeKey) => {
    const sendedConfirmations = useSelector<FeedbackReducer['sendedConfirmationTime']>(
        fp.getOr({}, `${SENDED_CONFIRMATION_TIME_PATH}`),
    );

    return sendedConfirmations[email];
};

export const useFeedbackBusy = (): FeedbackReducer['busy'] => useSelector(`${LANDING_DOMAIN_PATH}.${FEEDBACK_PATH}.busy`);
